module.exports = __webpack_public_path__ + "media/images/brand/photo04-e7371c45d0d7370a13382e03a54a644f.png";